// snackbar.service.ts
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private pendingMessage: string | null = null;

  constructor(private snackBar: MatSnackBar) {}

  // Call this before navigating
  queueMessage(message: string) {
    this.pendingMessage = message;
  }

  // Call this in ngOnInit of the next page
  showPendingMessage() {
    if (this.pendingMessage) {
      this.snackBar.open(this.pendingMessage, 'Ok', {
        duration: 6000,
        panelClass: ['snackbar-full-width']
      });
      this.pendingMessage = null;
    }
  }

  // For immediate use without navigation
  show(message: string) {
    this.snackBar.open(message, 'Ok', {
      duration: 6000,
      panelClass: ['snackbar-full-width']
    });
  }
}
